import React from 'react';
import ArticleField from '../ArticleField';
import TinyMCE from '../../atoms/TinyMCE';

interface BodyProps {
    value: string,
    onChange: (value: string) => void
}

const Body = (props: BodyProps) => (
    <ArticleField label="Body">
        <TinyMCE
            value={props.value}
            onEditorChange={props.onChange}
        />
    </ArticleField>
)

export default Body;